import { render, staticRenderFns } from "./documents-table.vue?vue&type=template&id=18c613d7"
import script from "./documents-table.vue?vue&type=script&lang=js"
export * from "./documents-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports